import "./LandingHero.css";
import {  Button, Flex, Grid, Loader } from "@mantine/core";
import { IconArrowRight, IconUsers } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import axios from "axios";
import HeroEventsCatalog from "../../../components/HeroEventsCatalog/HeroEventsCatalog";

function LandingHero() {
   return (
      <div className="landingHero__container">
         <Grid pb={100} py={30} w='100%'>
            <Grid.Col span={{ base: 12, md: 6 }}>
               <div className="landingHero__column">
                  <h1 className="landingHero__title">
                     Te acompañamos. <br />
                     <strong>Pensamos juntos.</strong>
                  </h1>

                  <div className="landingHero__block">
                     <p className="landingHero__text">
                        FORVET es la comunidad donde veterinarios de Latinoamérica construyen criterio clínico colectivo a través de mentoría horizontal, debate de casos reales y datos de nuestra región. </p>
                  </div>
                  {/* <SearchBanner /> */}

                  <Flex gap={16} w='100%' justify='start'>
                     <Button rightSection={<IconArrowRight size={16} />} component="a" href='#programas'>
                        Ver programas
                     </Button>
                     <Button variant="outline" color="var(--color-text-primary)" leftSection={<IconUsers size={16} />} component="a" href='#que-esta-pasando'>
                        Ver comunidad
                     </Button>
                  </Flex>
                  <Flex gap={16} w='100%' justify='start'>
                     <HeroCounter />
                  </Flex>
               </div>
            </Grid.Col>
            <HeroEventsCatalog />
         </Grid>
      </div >
   );
}

export default LandingHero;





const HeroCounter = () => {


   const [state, setState] = useState({
      isLoading: false,
      error: false,
      data: null
   })

   useEffect(() => {
      const getData = async () => {
         try {
            setState(prev => ({ ...prev, isLoading: true }))
            // Simulación de delay de red
            const URL = `${process.env.REACT_APP_BACKEND_SERVER}/info/getHomeLandingStats?is_student=true&is_country=true&is_pathology=true`
            const { data } = await axios.get(URL)
            setState(prev => ({ ...prev, data }))
         } catch (error) {
            console.log(error)
            setState(prev => ({ ...prev, error: true }))

         } finally {
            setState(prev => ({ ...prev, isLoading: false }))
         }
      }
      getData()
   }, [])

   if (state.isLoading) {
      return <Grid.Col span={{ base: 12, md: 6 }}>
         <Flex w='100%' justify='center' align='center' h='100%'>
            <Loader />
         </Flex>
      </Grid.Col>
   }

   if (state.error) return <></>


   const counter = state?.data?.counter


   return (
      <div className="hero-stats">

         {counter && counter?.map((item, idx) => (
            <div className="hero-stat" key={idx}>
               <div className="hero-stat-number">{item.count}</div>
               <div className="hero-stat-label">{item.label}</div>
            </div>
         ))}
      </div>
   )
}